<template>
  <div
    class="p-0 menu-application-dropdown"
  >
    <v-select
      v-if="!isSidebarCollapsed"
      v-model="activeProjectId"
      :clearable="false"
      :loading="false"
      :filter="lodashFilter"
      label="name"
      :options="projects"
      class="px-50"
      :selectable="(option) => option.publicProjectId !== activeProjectId.publicProjectId"
    >
      <template #footer>
        <hr>
      </template>
      <template #option="{id, name}">

        <div
          class="d-flex align-items-center"
        >
          <span class="d-flex flex-column">
            <p
              class="text-main m-0 ellipsis"
              style="max-width: 180px; -webkit-line-clamp: 2;"
            >{{ name }}</p>
            <p class="text-default text-xsm text-muted m-0">{{ id }}</p>
          </span>
        </div>
      </template>
      <template #open-indicator="{ attributes }">
        <span v-bind="attributes">
          <GjIcon name="DoubleArrow" />
        </span>
      </template>
      <template #selected-option="{name, publicProjectId}">
        <div
          class="d-flex align-items-center"
        >
          <GjIcon
            class="icon-left bd-highlight"
            name="Widget"
          />
          <div class="d-flex flex-column">
            <div class="text-main application-name-selected">
              {{ name }}
            </div>
            <div class="text-default text-xsm">
              {{ publicProjectId }}
            </div>
          </div>
        </div>
      </template>
    </v-select>
    <div
      v-else
      v-b-tooltip.hover.right
      class="p-75"
      :title="!showPopover ? 'Projects' : ''"
    >
      <a
        :id="`popover-project-select-list`"
        tabindex="0"
        @click="togglePopover"
      >
        <GjIcon :name="'Widget'" />
      </a>
      <b-popover
        v-if="showPopover && projects.length > 0"
        ref="popoverElement"
        :target="`popover-project-select-list`"
        triggers="manual"
        placement="right"
        :show="showPopover"
        tabindex="0"
        custom-class="popover-project-select-list"
      >
        <template #default>
          <div
            ref="selectElement"
            style="max-height: 200px; overflow: hidden auto; cursor: pointer;"
          >
            <div class="p-50">
              <div
                v-for="project in projects"
                :key="`project-${project.id}`"
                class="p-50 project-elements rounded"
                @click="activeProjectId = project"
              >
                <p
                  class="text-sm text-medium m-0 project-elements-title"
                >
                  {{ project.name }}
                </p>
                <p class="d-flex align-items-center text-xsm text-gray text-600 m-0">
                  ID: {{ project.id }}
                </p>
              </div>
            </div>
          </div>
        </template>
      </b-popover>
    </div>
  </div>
</template>

<script>
import ToastificationContent from '@toastification'

export default {
  data() {
    return {
      showPopover: false,
    }
  },
  computed: {
    activeOrganizationId() {
      const activeOrganizationId = this.$store.getters['organizationModule/getActiveOrganizationId']
      return activeOrganizationId
    },
    isSidebarCollapsed() {
      return this.$store.state.projectModule.isSidebarCollapsed && this.$store.state.app.windowWidth > 1199
    },
    activeProjectId: {
      get() {
        return this.$store.state.projectModule.activeProject || false
      },
      async set(value) {
        localStorage.setItem('projectId', value.id)
        await this.$store.commit('projectModule/SET_ACTIVE_PROJECT', {
          name: value.name,
          organizationId: this.activeOrganizationId,
          publicProjectId: value.id,
        })
        this.$store.commit('projectModule/UPDATE_IS_DROPDOWN_LOADING', false)
        if (!this.$route.meta?.errorPage) await this.$router.push({ name: this.$route.meta.navActiveLink || this.$route.name, params: { projectId: value.id } })
        else await this.$router.push({ name: 'dashboard', params: { projectId: value.id } })

        this.$toast({
          component: ToastificationContent,
          props: {
            icon: 'Widget',
            variant: 'success',
            text: `Project with name ${value.name} is active.`,
          },
        })
      },
    },
    projects() {
      return this.$store.state.projectModule.projects ? this.$store.state.projectModule.projects.filter(x => x.publicProjectId !== this.activeProjectId.publicProjectId) : []
    },
    selectedProject() {
      return this.$store.state.projectModule.activeProject?.name || ''
    },
  },
  async created() {
    this.$store.commit('projectModule/UPDATE_DROPDOWN_FILTER', { propKey: 'organizationId', value: localStorage.getItem('organizationId') })
    await this.$store.dispatch('projectModule/getProjectsOfUserAll')
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    handleOutsideClick(e) {
      const popover = this.$refs.popoverElement
      const select = this.$refs.selectElement

      if ((popover && popover.$el && !popover.$el.contains(e.target))
        && (select && !select.contains(e.target))) {
        this.showPopover = false
      }
    },
    togglePopover() {
      setTimeout(() => {
        this.showPopover = true
      }, 100)
    },
    lodashFilter(options, search) {
      return options.filter(option => option.name.toLowerCase().includes(search.toLowerCase())
      || option.id.toLowerCase().includes(search.toLowerCase())).filter(option => option.publicProjectId !== this.activeProjectId.publicProjectId)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/tokens/theme.scss';

.menu-application-dropdown {
  .v-select {

    // .vs__dropdown-toggle{
    //   height: 42px;
    // }

    .vs__selected{
      width: 200px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .vs__search {
      width: 204px;
    }

    .vs__dropdown-menu{
      width: 250px;

      li.vs__dropdown-option {
        // width: 250px;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        white-space: pre-line;

        &--highlight{
          &:after{
            // content: none !important;
          }
        }
      }
    }
  }

  .application-name-selected {
    width: 165px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .vs__open-indicator {
    transform: none !important;
    transition: none !important;
  }

  ul {
    overflow-x: hidden !important;
    padding: 8px 0;
    max-width: 94%;
    margin: 0 3% !important;
  }

  .vs__dropdown-toggle {
    height: 50px !important;
    border: none !important;
    cursor: pointer !important;
  }
}

.popover-project-select-list {
  .popover-body {
    padding: 0;
    .project-elements:hover {
      background: $gray-100;
      .project-elements-title {
        color: $dark-primary;
      }
    }
  }
}
</style>
